import { DateFilterEnum } from 'src/environment'

export enum CustomDateRangeOption {
	customDateRange = 'customDateRange'
}
export type DateRangeOptions = DateFilterEnum | CustomDateRangeOption
